"use client";

import { c as _c } from "react/compiler-runtime";
import { Loader2 } from "lucide-react";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { ArticleResultCard } from "./ArticleResultCard";
import type { SearchArticle } from "./useSearchPage";
interface ArticleResultListProps {
  title: string;
  articles: SearchArticle[];
  total: number;
  loadingMore: boolean;
  hasNextPage: boolean;
  error: boolean;
  onLoadMore: () => void;
  onRetry: () => void;
}
export function ArticleResultList(t0) {
  const $ = _c(36);
  const {
    title,
    articles,
    total,
    loadingMore,
    hasNextPage,
    error,
    onLoadMore,
    onRetry
  } = t0;
  const labels = useLabels();
  if (articles.length === 0) {
    return null;
  }
  let featured;
  let rest;
  if ($[0] !== articles) {
    [featured, ...rest] = articles;
    $[0] = articles;
    $[1] = featured;
    $[2] = rest;
  } else {
    featured = $[1];
    rest = $[2];
  }
  const t1 = labels.search?.showing || "Showing {shown} of {total}";
  let t2;
  if ($[3] !== articles.length || $[4] !== t1 || $[5] !== total) {
    t2 = t1.replace("{shown}", String(articles.length)).replace("{total}", String(total));
    $[3] = articles.length;
    $[4] = t1;
    $[5] = total;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const showingText = t2;
  let t3;
  if ($[7] !== title) {
    t3 = <h2 className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-3">{title}</h2>;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== featured) {
    t4 = <ArticleResultCard article={featured} featured={true} />;
    $[9] = featured;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== rest) {
    t5 = rest.length > 0 && <div className="mt-2">{rest.map(_temp)}</div>;
    $[11] = rest;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== error || $[14] !== labels.search?.retry || $[15] !== onRetry) {
    t6 = error && <div className="mt-6 text-center"><button type="button" onClick={onRetry} className="text-sm text-primary hover:underline cursor-pointer">{labels.search?.retry || "Try again"}</button></div>;
    $[13] = error;
    $[14] = labels.search?.retry;
    $[15] = onRetry;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== error || $[18] !== hasNextPage || $[19] !== labels.search?.loadMore || $[20] !== loadingMore || $[21] !== onLoadMore || $[22] !== showingText) {
    t7 = hasNextPage && !error && <div className="mt-6 flex flex-col items-center gap-2"><button type="button" onClick={onLoadMore} disabled={loadingMore} className="w-full py-3 px-4 border-2 border-dashed border-border rounded-lg font-medium text-foreground hover:bg-muted hover:border-primary/40 transition flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">{loadingMore && <Loader2 className="w-4 h-4 animate-spin" />}{labels.search?.loadMore || "Load more"}</button><div className="text-xs text-muted-foreground">{showingText}</div></div>;
    $[17] = error;
    $[18] = hasNextPage;
    $[19] = labels.search?.loadMore;
    $[20] = loadingMore;
    $[21] = onLoadMore;
    $[22] = showingText;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== articles.length || $[25] !== hasNextPage || $[26] !== showingText || $[27] !== total) {
    t8 = !hasNextPage && total > articles.length && <div className="mt-6 text-center text-xs text-muted-foreground">{showingText}</div>;
    $[24] = articles.length;
    $[25] = hasNextPage;
    $[26] = showingText;
    $[27] = total;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8) {
    t9 = <section className="mt-10">{t3}{t4}{t5}{t6}{t7}{t8}</section>;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
}
function _temp(article) {
  return <ArticleResultCard key={article.id} article={article} />;
}